import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Database from "../views/Database.vue";
import CompDB from "../views/CompDB.vue";
import Design from "../views/Design.vue";
import SNPSwap from "../views/SNPSwap.vue";
import Login from "../views/Login.vue";
import Register from "../views/Register.vue";
import ForgotPassword from "../views/ForgotPassword.vue";
import Test from "../views/Test.vue";
import FAQ from "../views/FAQ.vue";
import Users from "../views/Users.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/database",
    name: "database",
    component: Database
  },
  {
    path: "/compdb",
    name: "compdb",
    component: CompDB
  },
  {
    path: "/design",
    name: "design",
    component: Design
  },
  {
    path: "/snpswap",
    name: "snpswap",
    component: SNPSwap
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/register",
    name: "register",
    component: Register
  },
  {
    path: "/forgotpassword",
    name: "forgotpassword",
    component: ForgotPassword
  },
  {
    path: "/test",
    name: "test",
    component: Test
  },
  {
    path: "/faq",
    name: "faq",
    component: FAQ
  },
  {
    path: "/users",
    name: "users",
    component: Users
  },
  {
    path: "*",
    redirect: "/"
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;
